<template>
    <div class="redactor-field">
        <div class="redactor-field-field-disabled" v-if="disabled" v-html="value"></div>
        <redactor v-model="value" v-if="!disabled" :config="redactorConfig"></redactor>
    </div>
</template>
<script>
    import {abstractField} from 'vue-form-generator'
    import redactor from './redactor/RedactorVue'

    export default {
        mixins: [abstractField],
        components: {
            redactor
        },
        computed: {

            redactorConfig() {
                return {
                    clickToEdit: true,
                    lang: 'sk',
                    removeNewLines: true,
                    buttons: ['undo', 'redo', 'html', 'format', 'bold', 'italic', 'underline', 'sup', 'sub', 'deleted', 'lists', 'image', 'file', 'link', 'line', 'ol', 'ul', 'indent', 'outdent'],
                    placeholder: this.schema.placeholder,
                    callbacks: {}
                };
            }
        },
    };
</script>
<style lang="scss">
    @import './redactor/_scss/redactor';

    .redactor-field {
        width: 100%;

        .redactor-field-field-disabled {
            border: 1px solid #ced4da;
            padding: 8px 12px;
            border-radius: 4px;
            min-height: 38px;
            opacity: .6;
        }
    }

    .redactor-box.redactor-styles-on {
        border-color: #ced4da;
    }
</style>


// WEBPACK FOOTER //
// src/core/Form/Fields/Redactor.vue